// extracted by mini-css-extract-plugin
export default {"absolute":"Tooltip_absolute__lVnim"};